import compromisso from "../../../../assets/pages/NewHome/RentJourneySection/compromisso.svg";
import experiencia from "../../../../assets/pages/NewHome/RentJourneySection/experiencia.png";
import agilidade from "../../../../assets/pages/NewHome/RentJourneySection/agilidade.png";
import confianca from "../../../../assets/pages/NewHome/RentJourneySection/confianca.png";

export const BANNERS = [
  {
    title: "Compromisso",
    content:
      "Aqui, nosso maior objetivo é garantir sua satisfação. Acreditamos que cada cliente é único.",
    image: compromisso,
  },
  {
    title: "Experiência",
    content:
      "Com uma presença consolidada em diversas regiões do país, nossa atuação abrange mais de cinco estados.",
    image: experiencia,
  },
  {
    title: "Agilidade",
    content:
      "Sabemos que o tempo é essencial quando se trata de locação, por isso, oferecemos um processo ágil.",
    image: agilidade,
  },
  {
    title: "Confiança",
    content:
      "Oferecemos a confiança de um processo ágil e tranquilo, sempre priorizando o seu conforto.",
    image: confianca,
  },
];
